import { Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { DATA_LIMIT } from '../../data/constants';
import { formatDate, getParameters } from '../../lib/helper';
import ConfirmationModal from '../Modals/ConfirmationModal';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import MatTable from '../Tables/MatTable';
import Loader from '../CommonComp/CustomLoading/Loader';
import { chalanItemsSelector } from '../../redux/chalan';
import {
  deleteChalanDetail,
  getHeroChalanByDate,
} from '../../Services/chalanApis';
import { getObjectSubset } from '../../lib/helper';
const limit = DATA_LIMIT;

const column = [
  {
    label: 'Design SKU',
    id: 'design',
    format: (columnData, rowIndex, formatCallback, arr, errors, row) => (
      <Link
        className="textDecoration-none link-text"
        to={`/design/designDetail/${row?.design?._id}`}
      >
        <Typography
          variant="span"
          style={{ whiteSpace: 'nowrap', padding: '1rem' }}
          // className={'link-text'}
          // onClick={() => {
          //   customHistory.push(`order/orderDetails/${columnData}`);
          // }}
        >
          {row?.design?.sku}
        </Typography>
      </Link>
    ),
  },
  {
    label: 'Design Name',
    id: 'design',
    format: (columnData, rowIndex, formatCallback, arr, errors, row) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {row?.design?.sku || '-'}
      </span>
    ),
  },
  {
    label: 'Total Quantity In Challan',
    id: 'totalQuantity',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData || '-'}
      </span>
    ),
  },
];

function TopChalanList() {
  const [tableListing, setTableListing] = useState([]);
  const [isLoadingState, setIsLoadingState] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [page, setPage] = useState(1);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [allParams, setAllParams] = useState(getParameters());
  const { heroChalanList } = useSelector(chalanItemsSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const getListing = async (params = {}) => {
    const payload = {
      page: String(1),
      limit: limit,
      startDate: params?.start_date,
      endDate: params?.end_date,
    };
    if (payload?.tab) {
      delete payload?.tab;
    }
    dispatch(getHeroChalanByDate(payload));
    setPage(Number(payload.page));
  };
  useEffect(() => {
    getListing();
  }, []);
  useEffect(() => {
    if (heroChalanList?.items?.length >= 0) {
      setTableListing(heroChalanList?.items);
    }
  }, [heroChalanList.items]);

  const handleDelete = async (value) => {
    setIsLoadingState(true);
    try {
      if (value && deleteData) {
        const resp = await deleteChalanDetail(deleteData);
        if (resp) {
          getListing();
        }
        setIsLoadingState(false);
      } else {
        setDeleteData(null);
        setIsLoadingState(false);
      }
    } catch (e) {
      setIsLoadingState(false);
    }
  };

  const handleCofirmModalOpen = (value) => {
    setConfirmDelete(value);
  };
  // const actionHead = (data) => {
  //   return (<div style={{display: "flex"}}>
  //      hi
  //   </div>);
  // };

  return (
    <>
      {(heroChalanList?.loading || isLoadingState) && <Loader />}
      <MatTable
        loading={heroChalanList?.loading}
        showCheckbox={false}
        columns={column}
        data={tableListing}
        // requestSearch={requestSearch}
        // cancelSearch={cancelSearch}
        onApplyFilter={(data = {}) => {
          getListing({
            page: String(1),
            start_date: '',
            end_date: '',
            ...getObjectSubset(data, 'start_date', 'end_date'),
          });
          // if (Object.keys(data).length > 0) {
          //   setAllParams({
          //     ...allParams,
          //     page: String(1),
          //     ...getObjectSubset(data, 'start_date', 'end_date'),
          //   });
          // } else {
          //   setAllParams({
          //     page: String(1),
          //   });
          // }
        }}
        // showFilterButton={true}
        // actionHead={actionHead}
        page={page}
        // changeFilter={changeFilter}
        // handleFilterPopup={toggleFilters}
        perPage={limit}
        // setFilters={setFilters}
        // filters={filters}
        total={heroChalanList?.items || 0}
        // defaultSort="transactionTime"
        // defaultSortOrder={isMobile ? sortOrder : 'desc'}
        // searchTerm={searchTerm}
        setPage={setPage}
        // handleSearch={(searchTerm) => {
        //   getListing({
        //     page: String(1),
        //     search: searchTerm,
        //   });
        //   // setAllParams({
        //   //   ...allParams,
        //   //   page: String(1),
        //   //   search: searchTerm,
        //   // });
        // }}
        handlePageChange={(newPage) => {
          getListing({
            page: String(newPage),
          });
          // setAllParams({
          //   ...allParams,
          //   page: String(newPage),
          // });
        }}
        checkboxEnable={false}
        toolbarEnable={true}
        // toolBarButton={() => {
        //   return (
        //     <CustomButton
        //       sx={(theme) => ({
        //         fontSize: '12px',
        //         whiteSpace: 'nowrap',
        //         bgcolor: 'buttonSecondary.main',
        //         color: 'buttonSecondary.contrastText',
        //         [theme.breakpoints.down('md')]: {
        //           flex: 1,
        //         },
        //       })}
        //       onClick={() => {
        //         getExportFile();
        //       }}
        //       loading={expLoading}
        //     >
        //       Export XLS
        //     </CustomButton>
        //   );
        // }}
        pagination={true}
        filtersUrlData={allParams || {}}
        filterEnable
        rangeDateFilter
        onDelete={() => {}}
        dropdownFilter={true}
        // dropdownFilterOptions={ContactUsFiltersData.related_to}
      />
      {confirmDelete && (
        <ConfirmationModal
          open={confirmDelete}
          handleConfirm={handleDelete}
          setOpen={handleCofirmModalOpen}
        />
      )}
    </>
  );
}

export default TopChalanList;
